import React from "react";
import CompanyUsers from "./parts/CompanyUsers";
import InvitedUsers from "./parts/InvitedUsers";



export default function UsersTab() {
    return (
        <div className="flex flex-col gap-12">
            <CompanyUsers />
            <InvitedUsers />
        </div>

    )
}